module.exports = __webpack_public_path__ + "static/media/ic_app_logo.4cf36eb5.svg";